import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsSnowNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M3.61 37.079l5.94-3.429.28 7.93 1.96-1.13-.28-7.93 6.51-3.758 4.988 2.629v7.472l-7 3.719v2.27l7-3.719v6.853h2v-6.857l6.94 3.69V42.55l-6.94-3.69v-7.469l4.97-2.63 6.509 3.757-.28 7.92 1.96 1.14.28-7.93 5.94 3.43 1-1.732-5.937-3.429 6.67-4.167-1.97-1.13-6.656 4.167L31 27.038v-6.082l6.489-3.747 6.67 4.17 1.96-1.13-6.67-4.17 5.943-3.431-1-1.732-5.942 3.428-.28-7.92-1.96 1.136.28 7.91v.006l-6.5 3.753L25 16.58V9.12l7-3.73V3.13l-7 3.72V0h-2v6.85l-6.94-3.69v2.26L23 9.12v7.48l-4.97 2.64-6.52-3.765.28-7.92L9.83 6.42l-.28 7.92-5.94-3.425-1 1.732 5.943 3.431L1.88 20.24l1.96 1.14 6.67-4.17L17 20.955v6.084l-6.493 3.749L3.85 26.62l-1.97 1.13 6.668 4.169-5.937 3.428 1 1.732zM19 20.98l5.01-2.66L29 20.97v6.04l-4.99 2.65L19 27.01v-6.03z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSnowNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsSnowNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsSnowNormalLarge;
